// TODO: PTMDialog verwenden
import {
    Button, Checkbox,
    Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableHead, TableRow,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DragDropContext, Draggable } from "react-beautiful-dnd";
import React, { useEffect, useState } from "react";
import { produce } from "immer";
import StrictModeDroppable from "../StrictModeDroppable";

export default function ColumnEditor(props) {
    const {
        id, close, currentColumns, setCurrentColumns,
    } = props;

    const [newCurrentColumns, setNewCurrentColumns] = useState([]);

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const onDragEnd = (result) => {
        if (result.source && result.destination) {
            const newFilters = reorder(newCurrentColumns, result.source.index, result.destination.index);
            setNewCurrentColumns(reorder(newFilters));
        }
    };

    const toggleEnabled = (columnId) => {
        setNewCurrentColumns(produce(newCurrentColumns, (draft) => {
            const columnIndex = draft.findIndex((item) => item.id === columnId);
            draft[columnIndex].enabled = !draft[columnIndex].enabled;
        }));
    };

    const save = () => {
        setCurrentColumns(newCurrentColumns);
        close();
    };

    useEffect(() => {
        setNewCurrentColumns(currentColumns);
    }, []);

    return (
        <Dialog open>
            <DialogTitle>
                <FontAwesomeIcon icon="columns" fixedWidth />
                {" "}
                Spalteneditor
                <br />
                <small>
                    id:
                    {" "}
                    {id}
                </small>
            </DialogTitle>
            <DialogContent>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell><FontAwesomeIcon icon="eye" /></TableCell>
                            <TableCell>Spalte</TableCell>
                        </TableRow>
                    </TableHead>
                    <DragDropContext onDragEnd={onDragEnd}>
                        <StrictModeDroppable droppableId="table">
                            {(provided) => (
                                // eslint-disable-next-line react/jsx-props-no-spreading
                                <TableBody ref={provided.innerRef} {...provided.droppableProps}>
                                    {newCurrentColumns.map((column, index) => (
                                        <Draggable
                                            key={column.field}
                                            draggableId={column.id.toString()}
                                            index={index}
                                        >
                                            {(providedRow) => (
                                                <TableRow
                                                    ref={providedRow.innerRef}
                                                    // eslint-disable-next-line react/jsx-props-no-spreading
                                                    {...providedRow.draggableProps}
                                                    // eslint-disable-next-line react/jsx-props-no-spreading
                                                    {...providedRow.dragHandleProps}
                                                    style={{
                                                        ...providedRow.draggableProps.style,
                                                        width: "100%",
                                                    }}
                                                >
                                                    <TableCell><Checkbox checked={column.enabled} style={{ padding: 0 }} onChange={() => toggleEnabled(column.id)} disabled={column.required} /></TableCell>
                                                    <TableCell>{column.title}</TableCell>
                                                </TableRow>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </TableBody>
                            )}
                        </StrictModeDroppable>
                    </DragDropContext>
                </Table>
            </DialogContent>
            <DialogActions>
                <Button onClick={save} color="primary">
                    <FontAwesomeIcon icon="save" fixedWidth />
                    Speichern
                </Button>
                <Button onClick={close} color="primary">
                    <FontAwesomeIcon icon="times" fixedWidth />
                    Abbrechen
                </Button>
            </DialogActions>
        </Dialog>
    );
}
